import { forwardRef, type Ref, type SVGProps } from "react";
const IconCopyOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M26.9 24H13.1a2.1 2.1 0 0 1-2.1-2.1V4.1A2.1 2.1 0 0 1 13.1 2h13.8A2.1 2.1 0 0 1 29 4.1v17.8a2.1 2.1 0 0 1-2.1 2.1m0-19.9H13.1v17.8h13.8zM7 27.94l3 .01V30H7.06A2.06 2.06 0 0 1 5 27.94V25h2.01zm9 .04V30h-4v-2.04zm4.94.02.06-2h2v1.94A2.06 2.06 0 0 1 20.94 30H18v-2.01zM5 12.06A2.06 2.06 0 0 1 7.06 10H9v2H7.06l-.01 3H5zM7.04 17l-.02 6H5v-6z" />
  </svg>
);
const ForwardRef = forwardRef(IconCopyOutlineSVG);
ForwardRef.displayName = "IconCopyOutline";
export { ForwardRef as IconCopyOutline };
